import React, { useState } from 'react'; //import React Component
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { auth, cloudStore } from '../firebase';
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { doc, setDoc, query, collection, where, getDoc, getDocs } from 'firebase/firestore';
export function Signup() {

    //(Function: Collect Data & Show Img)Collect input information, set value by ID
    const [name, setname] = useState("")
    const [phone, setphone] = useState("")
    const [expandForm, setForm] = useState(false)
    const [otp, setotp] = useState("")
    const [wechat, setwechat] = useState("")
    const [location, setlocation] = useState("")
    const [password, setpassword] = useState("")
    const [password2, setpassword2] = useState("")

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === "name") {
            setname(value);
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[0].style.color = "#868686"
            }
        }
        if (id === "phone") {
            setphone(value);
            if (value.trim().length >= 10) {
                document.getElementsByTagName("label")[5].style.color = "#868686"
            }
        }
        if (id === "otp") {
            setotp(value);
            if (value.trim().length >= 6) {
                document.getElementsByTagName("label")[6].style.color = "#868686"
            }
        }
        if (id === "wechat") {
            setwechat(value);
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[3].style.color = "#868686"
            }
        }
        if (id === "location") {
            setlocation(value);
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[4].style.color = "#868686"
            }
        }
        if (id === "password") {
            setpassword(value);
            if (value.trim().length >= 6) {
                document.getElementsByTagName("label")[1].style.color = "#868686"
            }
        }
        if (id === "password2") {
            setpassword2(value);
            if (value.trim().length >= 6) {
                document.getElementsByTagName("label")[2].style.color = "#868686"
            }
        }
        if (id === "checkBox") {
            document.querySelector(".accept_box label").style.color = "#868686"
        }
    }
    //(Function: Collect Data & Show Img)--------------------------------------------------------------------------

    const requestOTP = async (e) => {
        e.preventDefault();
        const phoneExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.phone", "==", phone)));
        const phoneData = phoneExist.docs.map(doc => doc.data());
        let realphone = "+1" + phone
        if (realphone.length >= 12) {
            if (phoneData.length > 0) {
                var newDiv = document.createElement("div");
                var text = "";
                newDiv.classList.add("tips");
                setTimeout(() => { newDiv.classList.add("disappear") }, 4500);
                let button = document.querySelector('.optButton');
                text = document.createTextNode("手机号已存在.");
                newDiv.appendChild(text);
                button.after(newDiv);
                document.getElementsByTagName("label")[5].style.color = "red"
            } else {
                setForm(true)
                window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
                    'size': 'invisible',
                    'callback': (response) => {
                        // reCAPTCHA solved, allow signInWithPhoneNumber.

                    }
                }, auth);
                let appVerifier = window.recaptchaVerifier;
                signInWithPhoneNumber(auth, realphone, appVerifier)
                    .then((confirmationResult) => {
                        window.confirmationResult = confirmationResult;
                    }).catch((error) => {
                        console.log(error)
                    });
            }

        } else {
            var newDiv = document.createElement("div");
            var text = "";
            newDiv.classList.add("tips");
            setTimeout(() => { newDiv.classList.add("disappear") }, 4500);
            let button = document.querySelector('.optButton');
            text = document.createTextNode("请检查手机号.");
            newDiv.appendChild(text);
            button.after(newDiv);
            document.getElementsByTagName("label")[5].style.color = "red"
        }
    }

    // (Function: Signup)Sign up after click, store data in firebase(cloud store, storage, auth)
    const makeAuth = async () => {
        let tips = document.getElementById("snackbar");
        let text = "";

        let check = document.querySelector(".accept_button");
        let userID = getRandomInt(1000, 9999) + name;

        //Filter error operation
        if (name.trim().length !== 0 && phone.trim().length !== 0 && wechat.trim().length !== 0 && location.trim().length !== 0 &&
            password.length !== 0 && password2.length !== 0 && check.checked && otp.trim().length !== 0) {
            const userExist = await getDoc(doc(cloudStore, "userData", userID)); //User exsit
            const phoneExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.phone", "==", phone)));
            const phoneData = phoneExist.docs.map(doc => doc.data());

            if (userExist.exists()) {
                document.getElementsByTagName("label")[0].style.color = "red"
                text = document.createTextNode("用户命已存在.");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else if (phoneData.length > 0) {
                document.getElementsByTagName("label")[5].style.color = "red"
                text = document.createTextNode("电话号码已存在");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else if (name.match("%20") || name.match(":&:")) {
                document.getElementsByTagName("label")[0].style.color = "red"
                text = document.createTextNode("For security, we are not allowed string ':&:' and '%20'.");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else if (password.length < 6 || password2.length < 6) {
                document.getElementsByTagName("label")[0].style.color = "red"
                text = document.createTextNode("请输入6位密码");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else if (phone.length !== 10) {
                document.getElementsByTagName("label")[5].style.color = "red"
                text = document.createTextNode("请输入正确的手机号.");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else if (password !== password2) {
                document.getElementsByTagName("label")[1].style.color = "red"
                document.getElementsByTagName("label")[2].style.color = "red"
                text = document.createTextNode("请输入相同密码.");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else if (otp.length !== 6) {
                document.getElementsByTagName("label")[6].style.color = "red"
                text = document.createTextNode("请检查验证码长度.");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            } else {
                //Successfully create
                let confirmationResult = window.confirmationResult;
                confirmationResult.confirm(otp).then((result) => {
                    const docData = { //Used for store in firebase
                        "Personal_Information": {
                            userID: userID,
                            name: name,
                            phone: phone,
                            wechat: wechat,
                            location: location,
                            password: password
                        },
                        "会员等级": {
                            level: 0,
                            buyingPower: 0,
                        },
                        "officer": false
                    }
                    setDoc(doc(cloudStore, "userData", userID), docData)
                        .then(() => {
                            document.getElementById("name").value = "";
                            document.getElementById("phone").value = "";
                            document.getElementById("wechat").value = "";
                            document.getElementById("otp").value = "";
                            document.getElementById("location").value = "";
                            document.getElementById("password").value = "";
                            document.getElementById("password2").value = "";
                            var text = document.createTextNode("完成！");
                            tips.style.color = "red"
                            tips.appendChild(text)
                            tips.className = "show";
                            setTimeout(() => {
                                tips.className = tips.className.replace("show", "disappearFade");
                                setTimeout(() => {
                                    tips.innerHTML = '';
                                }, 300);
                            }, 2000);
                            setTimeout(() => {
                                if (window.location.pathname === "/signup") {
                                    window.location.href = "/login";
                                }
                            }, 2000);
                        });
                    text = document.createTextNode("谢谢注册！请等待加载，不要刷新页面.");
                    tips.appendChild(text)
                    tips.className = "show";
                    setTimeout(() => {
                        tips.className = tips.className.replace("show", "disappearFade");
                        setTimeout(() => {
                            tips.innerHTML = '';
                        }, 300);
                    }, 2000);
                }).catch((error) => {
                    document.getElementsByTagName("label")[6].style.color = "red"
                    text = document.createTextNode("请检查您的验证码.");
                    tips.appendChild(text)
                    tips.className = "show";
                    setTimeout(() => {
                        tips.className = tips.className.replace("show", "disappearFade");
                        setTimeout(() => {
                            tips.innerHTML = '';
                        }, 300);
                    }, 2000);
                });
            }
        } else {
            if (name.trim().length === 0) {
                document.getElementsByTagName("label")[0].style.color = "red"
            }
            if (password.length === 0) {
                document.getElementsByTagName("label")[1].style.color = "red"
            }
            if (password2.length === 0) {
                document.getElementsByTagName("label")[2].style.color = "red"
            }
            if (wechat.trim().length === 0) {
                document.getElementsByTagName("label")[3].style.color = "red"
            }
            if (location.trim().length === 0) {
                document.getElementsByTagName("label")[4].style.color = "red"
            }
            if (phone.trim().length !== 10) {
                document.getElementsByTagName("label")[5].style.color = "red"
            }
            if (otp.trim().length === 0) {
                document.getElementsByTagName("label")[6].style.color = "red"
            }
            if (!check.checked) {
                document.querySelector(".accept_box label").style.color = "red"
            }
            text = document.createTextNode("请输入全部信息.");
            tips.appendChild(text)
            tips.className = "show";
            setTimeout(() => {
                tips.className = tips.className.replace("show", "disappearFade");
                setTimeout(() => {
                    tips.innerHTML = '';
                }, 300);
            }, 2000);
        }
    }
    //(Function: Signup)-------------------------------------------------------------------------------------------

    return (
        <div id="login_page">
            <Navigation />
            <main>
                <div className="login">
                    <div className="login_content signup">
                        <div className="area">
                            <ul className="circles">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                        </div>
                        <h1 className="login_title">Signup</h1>
                        <form>
                            <label htmlFor="name">名字: </label>
                            <input
                                type="text"
                                id="name"
                                placeholder="请填写您的名字"
                                onChange={(e) => handleInputChange(e)}
                                value={name}
                            />
                            <br />
                            <label htmlFor="password">密码: </label>
                            <input
                                type="text"
                                id="password"
                                name="password"
                                placeholder="设置密码"
                                onChange={(e) => handleInputChange(e)}
                                value={password}
                            />
                            <br />
                            <label htmlFor="Password2">确认密码: </label>
                            <input
                                type="text"
                                id="password2"
                                placeholder="确认密码"
                                onChange={(e) => handleInputChange(e)}
                                value={password2}
                            />
                            <br />
                            <label htmlFor="wechat">微信号: </label>
                            <input
                                type="text"
                                id="wechat"
                                placeholder="请填写您的微信号，方便我们添加您"
                                onChange={(e) => handleInputChange(e)}
                                value={wechat}
                            />
                            <br />
                            <label htmlFor="location">地址: </label>
                            <input
                                type="text"
                                id="location"
                                placeholder="请填写您的住址，方便我们配送"
                                onChange={(e) => handleInputChange(e)}
                                value={location}
                            />
                            <br />
                            <label htmlFor="phone" style={{ color: "#868686" }}>手机号: </label>
                            <p style={{ fontSize: "25px", margin: "10px 0 0 0", color: "#c94b34" }}>不用填写地域号</p>
                            <input
                                type="tel"
                                id="phone"
                                placeholder="请填写您的电话，方便我们联系您"
                                onChange={(e) => handleInputChange(e)}
                                value={phone}
                            />
                            <br />
                            {expandForm === true ?
                                <>
                                    <label htmlFor="otp">验证码: </label>
                                    <input
                                        type="number"
                                        id="otp"
                                        placeholder="Write recieved OTP"
                                        onChange={(e) => handleInputChange(e)}
                                        value={otp}
                                    />
                                </> : null

                            }
                            {expandForm === false ?
                                <>
                                    <div className="button submit optButton" onClick={requestOTP} style={{ width: "200px", marginTop: "0" }}>发送验证码</div>
                                </> : null

                            }
                            <div id='recaptcha-container'></div>
                            <br />
                            <div className="create_account accept_box">
                                <label><input id="checkBox" onChange={(e) => handleInputChange(e)} className="accept_button" type="checkbox" />
                                    接受表示同意我们记录您的信息
                                </label>
                            </div>
                            <div className="button submit imporsub" onClick={makeAuth}>提交</div>
                        </form>
                    </div>
                    <div id="snackbar"></div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
} 